<template>
  <v-container fluid class="px-4 px-md-8">
    <p class="headline font-weight-bold my-4">{{ $t('pedido.totem.carrito.modo.titulo') }}</p>
    <v-row>
      <v-col v-for="card in cards" :key="card.title" cols="12" md="6">
        <v-list-item-group>
          <v-card @click="choosenService(card.modo)" :elevation="2" tile outlined>
            <v-img :src="card.src" class="black--text align-end" :height="alturaDinamica">
              <v-card-title class="display-1 pl-12 d-none d-sm-flex">{{$t(card.title)}}</v-card-title>
              <v-card-title class="title d-flex d-sm-none">{{$t(card.title)}}</v-card-title>
            </v-img>
          </v-card>
        </v-list-item-group>
      </v-col>
    </v-row>
  </v-container>
</template>

<!--<template>
  <v-container>
    <h2 class="my-3">{{ $t('pedido.totem.carrito.modo.titulo') }}</h2>

    <v-row dense>
      <v-col v-for="card in cards" :key="card.title" :xs="card.xs" :sm="card.sm" class="pa-4">
        <v-card tile @click="choosenService(card.modo)">
          <v-img
            :src="card.src"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            height="250px"
          ></v-img>

          <v-card-title class="d-flex py-4 justify-center display-1">{{$t(card.title)}}</v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>-->

<script>
import { mapState } from "vuex";
export default {
  props: {},
  data: () => ({
    cards: [
      {
        title: "pedido.totem.carrito.modo.btn.domicilio",
        src: "img/modo/delivery.png",
        modo: "domicilio",
        sm: 6,
        xs: 12
      },
      {
        title: "pedido.totem.carrito.modo.btn.recoger",
        src: "img/modo/pickup.png",
        modo: "recoger",
        sm: 6,
        xs: 12
      }
    ]
  }),
  computed: {
    ...mapState({
      isMobile: state => state.app.isMobile
    }),
    alturaDinamica() {
      if (this.isMobile) {
        return 160;
      } else {
        return 300;
      }
    }
  },
  methods: {
    choosenService(service) {
      this.$store.commit("pedido/setModo", service);
      this.$router.push("/pedir/" + service);
    }
  },
  updated() {},
  mounted() {
    if (this.$store.state.pedido.activePedido) {
      this.$store.commit("pedido/setContinuePedido", true);
    }
  }
};
</script>

<style scoped>
.vh-75 {
  height: 75vh;
}
.vh-35 {
  height: 35vh;
}
</style>